import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import MeetingLocalVideo from './MeetingLocalVideo';
import { HEADER_HEIGHT, FOOTER_HEIGHT } from 'flow/utils/meeting-constants';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectRightPanelActive } from 'flow/selectors/meeting-selectors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SenderAloneView = function SenderAloneView(_ref) {
  var isMinimizedView = _ref.isMinimizedView,
    isFullscreenOrNarrow = _ref.isFullscreenOrNarrow,
    shouldShowSenderInGrid = _ref.shouldShowSenderInGrid;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var sideBarScrollBehaviour = {
    overflowY: 'auto'
  };
  var rightPanelActive = useAppSelector(selectRightPanelActive);
  var getContainerClass = function getContainerClass() {
    if (isMinimizedView) {
      return 'flex start-0 w-full justify-center';
    } else if (isFullscreenOrNarrow) {
      return 'flex justify-center items-center flex-wrap';
    } else {
      return 'flex bg-black text-white flex-col absolute top-1.5 start-1.5 sideBarContainer [&::-webkit-scrollbar]:hidden';
    }
  };
  var getGridStyle = function getGridStyle() {
    if (isFullscreenOrNarrow || isMinimizedView) {
      return {
        width: 'inherit',
        height: 'inherit'
      };
    } else {
      return _objectSpread(_objectSpread({}, sideBarScrollBehaviour), {}, {
        height: "calc(100% - ".concat(HEADER_HEIGHT + FOOTER_HEIGHT, "px)"),
        content: 'test',
        width: 360
      });
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: twMerge(getContainerClass()),
    style: getGridStyle(),
    children: [isMinimizedView || !shouldShowSenderInGrid ? /*#__PURE__*/_jsx("div", {
      className: twMerge('sender-alone flex items-center justify-center bg-black text-white', !isFullscreenOrNarrow ? 'top-0 h-full' : 'top-1/2', rightPanelActive && 'hidden'),
      children: /*#__PURE__*/_jsx("div", {
        children: i18next.t('videoconference.video_grid.no_other_participants')
      })
    }) : null, !isMinimizedView && /*#__PURE__*/_jsx(MeetingLocalVideo, {})]
  });
};
export default SenderAloneView;